const rows = [
  { feature: "Appointment Required", fpc: false, agency: true },
  { feature: "Dedicated Agent", fpc: true, agency: false },
  { feature: "Error Review Before Submission", fpc: true, agency: false },
  { feature: "Daily Status Updates", fpc: true, agency: false },
  { feature: "No Trip to Seattle (700+ miles)", fpc: true, agency: false },
  { feature: "Ship from Home", fpc: true, agency: false },
  { feature: "Available During Gov. Slowdowns", fpc: true, agency: false },
];

export default function ComparisonSection() {
  return (
    <section id="comparison" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Comparison</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. Seattle Regional Agency
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            The Denver Regional Passport Agency is the closest agency to Boise — but it&apos;s 800+ miles away via I-84 and I-25. Here&apos;s why Boise travelers choose Fast Passport Center instead.
          </p>
        </div>

        <div className="bg-amber-50 border border-[#F6C344]/40 rounded-lg p-5 md:p-6 mb-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div className="flex-1">
              <h3 className="font-bold text-base text-[#1A365D] mb-1">Passport Agency Appointment Not Available?</h3>
              <p className="text-sm text-gray-600">Don't let a booked-out agency appointment block your travel plans. We bypass the agency bottleneck with reserved daily courier slots — faster and no appointment roulette.</p>
            </div>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
            >
              Get Started <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="grid grid-cols-3 bg-[#1A365D] text-white text-sm font-bold">
            <div className="p-4">Feature</div>
            <div className="p-4 text-center text-[#F6C344]">Fast Passport Center</div>
            <div className="p-4 text-center text-white/60">Seattle Agency</div>
          </div>
          {rows.map((r, i) => (
            <div
              key={i}
              className={`grid grid-cols-3 border-t border-gray-100 ${i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]"}`}
            >
              <div className="p-4 text-sm text-gray-700 font-medium">{r.feature}</div>
              <div className="p-4 flex items-center justify-center">
                {r.fpc ? (
                  <i className="ri-check-line text-green-500 text-lg"></i>
                ) : (
                  <i className="ri-close-line text-red-400 text-lg"></i>
                )}
              </div>
              <div className="p-4 flex items-center justify-center">
                {r.agency ? (
                  <i className="ri-check-line text-green-500 text-lg"></i>
                ) : (
                  <i className="ri-close-line text-red-400 text-lg"></i>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}